import { Box, Text } from '@nimbus-ds/components';
import { Trans, useTranslation } from 'react-i18next';
import { useResponsive } from 'commons/components';
import { useGetCountry } from 'domains/Auth/hooks';
import { NuvemChatPlan } from './NuvemChatPlan';

export type CountryCode = 'MX' | 'BR' | 'AR' | 'CL' | 'CO';

export type TierType = 'tier-1' | 'tier-2' | 'tier-3';
export type OptionalTierType = 'tier-free' | 'tier-top';
export type AllTierType = TierType | OptionalTierType;

export interface PricingPlan {
  tier: string;
  price: number;
}

export interface CountryPricing {
  currency: string;
  plans: PricingPlan[];
}

export type PricingStructure = Record<CountryCode, CountryPricing>;

// Ejemplo de implementación
export const pricingData: PricingStructure = {
  MX: {
    currency: 'MXN',
    plans: [
      { tier: 'tier-free', price: 4.2 },
      { tier: 'tier-1', price: 3 },
      { tier: 'tier-2', price: 2.4 },
      { tier: 'tier-3', price: 2.2 },
      { tier: 'tier-top', price: 1.8 },
    ],
  },
  BR: {
    currency: 'R',
    plans: [
      { tier: 'tier-free', price: 1.2 },
      { tier: 'tier-1', price: 0.8 },
      { tier: 'tier-2', price: 0.7 },
      { tier: 'tier-3', price: 0.6 },
      { tier: 'tier-top', price: 0.5 },
    ],
  },
  AR: {
    currency: 'ARS',
    plans: [
      { tier: 'tier-free', price: 260 },
      { tier: 'tier-1', price: 190 },
      { tier: 'tier-2', price: 150 },
      { tier: 'tier-3', price: 140 },
      { tier: 'tier-top', price: 125 },
    ],
  },
  CL: {
    currency: 'CLP',
    plans: [
      { tier: 'tier-1', price: 140 },
      { tier: 'tier-2', price: 110 },
      { tier: 'tier-3', price: 100 },
    ],
  },
  CO: {
    currency: 'COP',
    plans: [
      { tier: 'tier-1', price: 625 },
      { tier: 'tier-2', price: 500 },
      { tier: 'tier-3', price: 450 },
    ],
  },
};
export function NuvemChatPlans() {
  const { t } = useTranslation('nuvemchat');
  const storeCountry = useGetCountry();
  const currentStoreBilling = pricingData[storeCountry];
  const { isMobile } = useResponsive();

  return (
    <>
      <Box display="flex" flexDirection="column" alignItems="center" gap="4">
        <Box width="100%" height="auto" backgroundColor="neutral-surface">
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            gap="2"
          >
            <Text fontSize="base" color="neutral-textHigh" textAlign="left">
              {t('plans.subtitle')}
            </Text>
          </Box>
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" gap="4" paddingBottom="20">
        <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} gap="4">
          {currentStoreBilling?.plans.map((plan) => {
            const price =
              storeCountry === 'BR'
                ? `${currentStoreBilling?.currency}$${plan.price} `
                : `$${plan.price} ${currentStoreBilling?.currency}`;
            return (
              <NuvemChatPlan
                title={t(`plans.${plan.tier}`)}
                price={price}
                key={plan.tier}
              />
            );
          })}
        </Box>

        <Text fontSize="base" color="neutral-textHigh" textAlign="left">
          <Trans
            t={t}
            i18nKey="plans.helpText"
            components={{ bold: <strong /> }}
          />
        </Text>
      </Box>
    </>
  );
}
